import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import disclaimerSaga from './sagas';
import SignOutScreen from './containers/SignOutScreen';
import bannerRoutingSaga from './sagas/bannerRoutingSaga';
import { withLoadingWidgetHoc } from '../../components/lazyLoading/with-loading-widget-hoc';

export default {
  config,
  sagas: [disclaimerSaga, bannerRoutingSaga],
  routes: {
    '/signOut': {
      exact: false,
      container: withLoadingWidgetHoc(SignOutScreen),
    },
  },
} as ModuleConfig;
